module.exports = __webpack_public_path__ + "img/dep_household.60095186.png";